module.exports = __webpack_public_path__ + "static/MOTIVOP_logo_V_Blanc-a0563ceedccb54e5b98857276f6d25ac.png";